export default "__VITE_ASSET__58e7489d__"